import { AccessLevel } from '@dev/ee-api/ee-api-models';
import { palette } from '@dev/ee-components';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { getAccountAccessLevel, getGeneralInfo } from '@/store/account/actions';
import useMobile from '@/services/hooks/useMobile';

export const useDefaultContactActionMenuOptions = () => {
    const isMobile = useMobile();
    const { t } = useTranslation();
    const { listname } = useParams<{ listname: string }>();
    const isList = !!listname;
    const { EnableContactFeatures } = useSelector(getGeneralInfo);
    const accountAccessLevels = useSelector(getAccountAccessLevel);
    const canModifyContacts = accountAccessLevels.includes(AccessLevel.ModifyContacts);
    const canExport = accountAccessLevels.includes(AccessLevel.Export);

    const options = [
        ...((isMobile && [
            {
                label: t('addtolist'),
                value: 'addtolist',
                available: canModifyContacts && EnableContactFeatures,
            },
        ]) ||
            []),
        {
            label: t('export'),
            value: 'exportselected',
            available: canExport && !isMobile,
        },
        {
            label: t('changeconsenttracking'),
            value: 'changeconsenttracking',
            available: canModifyContacts,
        },
        {
            label: t('changestatus'),
            value: 'changestatus',
            available: canModifyContacts,
        },
        {
            label: t('removefromlist'),
            value: 'removefromlist',
            available: canModifyContacts && isList,
        },
        {
            label: t('deletepermanently'),
            value: 'deletecontacts',
            available: canModifyContacts,
            color: palette.red[6],
        },
    ];
    return options.filter((option): boolean => option.available);
};
